class ButtonFilters extends HTMLElement {
  constructor() {
    super();
    this.btns = this.querySelectorAll('.button-filters__btn');
    this.btns.forEach(btn => btn.addEventListener('click', this.onBtnClick.bind(this)));
  }

  onBtnClick(e) {
    const btn = e.target.classList.contains('button-filters__btn') ? e.target : e.target.closest('.button-filters__btn');

    // 1. Open filter drawer
    const filterDrawerBtn = document.querySelector(`.mobile-facets__wrapper`).querySelector('summary');
    filterDrawerBtn.click();
    
    // 2. Open related filter    
    if (btn.dataset.filter && document.querySelector(`.mobile-facets ${btn.dataset.filter}`).querySelector('summary')) {
      const relatedFilter = document.querySelector(`.mobile-facets ${btn.dataset.filter}`).querySelector('summary');
      relatedFilter.click();
    }


  }
}

customElements.define('button-filters', ButtonFilters);